<template>
  <ul
    v-if="breadcrumb.length > 0"
    class="breadcrumb"
    :class="cssClasses">
    <li v-for="(item, index) in breadcrumb" :key="index" class="breadcrumb__item">
      <a :href="item.url" class="breadcrumb__item-url">{{ item.name }}</a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    overrideItems: null
  }),
  computed: {
    breadcrumb() {
      return this.overrideItems || this.items
    }
  },
  mounted() {
    this.subscribe('breadcrumb.update', (items) => {
      this.overrideItems = items
    })
  }
}
</script>

<style lang="scss">
.breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: -#{measure(quarter)} 0 0 0;
  width: 100%;
  overflow: hidden;
}

.breadcrumb__item {
  display: none;
  align-items: center;
  margin-right: measure(quarter);
  margin-top: measure(quarter);

  &::after {
    @include background-svg(caretBlack);
    content: '';
    display: inline-block;
    width: 0.4375rem;
    height: 0.7rem;
    margin-left: measure(quarter);
  }

  &:last-child::after {
    display: none;
  }

  @include media(small) {
    display: flex;
  }
}

.breadcrumb__item:last-child .breadcrumb__item-url {
  pointer-events: none;
  color: color(disabled-breadcrumb);
}

.breadcrumb__item:nth-last-child(-n + 3) {
  @include media(to-small) {
    display: flex;
  }
}

.breadcrumb__item-url {
  position: relative;
  display: inline-block;
  border: none;
  color: color(text);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
